import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import ReactSelect from "react-select";
import SoftBox from "components/SoftBox";
import { useAgencyInfo } from "context/agency";
import infoimg from "../../info.png";
import { FormControlLabel, Icon, Switch, Tooltip } from "@mui/material";
import { Button, TextField } from "@mui/material";
import env from "config/env";
import localforage from "localforage";
import { useUpdateAssistant } from "queries/assistants";
import { usePromptLabels } from "queries/promptLabels";

function ModalComponent({
  open,
  onClose,
  item,
  handleRefresh,
  supperAdminData,
  assistant_type,
  pluginsdata,
  openUserAccountTemplates,
}) {
  const [agency] = useAgencyInfo();
  const [contentCreativity, setContentCreativity] = useState(item.content_creativity);
  const [btgen, setBtgen] = useState(item.btgen);
  const [waiting, setWaiting] = useState(false);
  const [tags, setTags] = useState(item.prompt_label_ids.map((data) => data._id));
  const [checkbox, setCheckbox] = useState(item.readonly);

  const { mutateAsync: updateAssistant } = useUpdateAssistant();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setWaiting(true);
    const payload = {
      assistant_name: e.target.assistant_name.value,
      purpose: e.target.purpose.value,
      modal_name: "openai/gpt-4o",
      type: "agency",
      content_creativity: parseFloat(contentCreativity),
      btgen: parseFloat(btgen),
      prompt_label_ids: tags,
      agency_id: agency._id,
      _id: item._id,
      readonly: checkbox,
      assistant_id: item.assistant_id,
      advanceConversationMode: advanceConversationMode,
      numberOfMessages: numberOfMessages,
      messageDelayTime: messageDelayTime,
      function_names: editplugins ? editplugins.filter((item) => item !== "") : editplugins,
    };

    const newAssistant = await updateAssistant({ payload, toaster: true });
    setShowAdvancedSettings(false);
    if (newAssistant) {
      onClose();
      setWaiting(false);
    }
  };

  const handleCCInputChange = (event) => {
    const tempSliderValue = parseFloat(event.target.value);
    const maxSliderValue = parseFloat(event.target.max);
    const progress = (tempSliderValue / maxSliderValue) * 100;

    const rangeInput = document.querySelector(".range-input");
    if (rangeInput) {
      rangeInput.style.background = `linear-gradient(to right, gray ${progress}%, #ccc ${progress}%)`;
    }

    setContentCreativity(tempSliderValue);
  };

  const handleBtInputChange = (event) => {
    const tempSliderValue = parseFloat(event.target.value);
    const maxSliderValue = parseFloat(event.target.max);
    const progress = (tempSliderValue / maxSliderValue) * 100;

    const rangeInput = document.querySelector(".range-input1");
    if (rangeInput) {
      rangeInput.style.background = `linear-gradient(to right, gray ${progress}%, #ccc ${progress}%)`;
    }
    setBtgen(tempSliderValue);
  };

  // tagsoption itself was dead state pre-migration (set but never rendered
  // in this modal) - the query is kept (via the shared hook) only because it
  // was already being fetched; see migration report.
  const { data: promptLabelsData } = usePromptLabels({ agencyId: agency._id, type: "agency" });
  const tagsoption = (promptLabelsData || []).filter((item) => item.api_type === "team");
  const handlechecbox = () => {
    setCheckbox(!checkbox);
  };
  const [showAdvancedSettings, setShowAdvancedSettings] = useState(false);
  const [advanceConversationMode, setAdvanceConversationMode] = useState(
    item?.advanceConversationMode
  ); // State for the toggle button
  const [numberOfMessages, setNumberOfMessages] = useState(item?.numberOfMessages); // State for the first number input field
  const [messageDelayTime, setMessageDelayTime] = useState(item?.messageDelayTime);
  const [editplugins, setEditPlugins] = useState(item.function_names);

  useEffect(() => {
    setEditPlugins(item?.function_names || []); // Update state whenever item plugins change
    setNumberOfMessages(item?.numberOfMessages);
    setMessageDelayTime(item?.messageDelayTime);
    setAdvanceConversationMode(item?.advanceConversationMode);
  }, [item?.function_names]);
  // Toggle Advanced Settings
  const handleAdvancedSettingsClick = () => {
    setShowAdvancedSettings(!showAdvancedSettings);
  };

  // Handle Toggle Button Change
  const handleToggleChange = (event) => {
    setAdvanceConversationMode(event.target.checked);
  };

  // Handle Number Input Change
  const handleNumberInputChange = (event, setter) => {
    setter(event.target.value);
  };

  const handlePluginsChange = (event) => {
    const plugin = agency?.default_plugins?.find((plugin) => plugin.name === event.target.name);
    if (!plugin) return; // Ensure the plugin exists

    const pluginName = plugin.name;

    setEditPlugins(
      (prevState) =>
        prevState.includes(pluginName)
          ? prevState.filter((name) => name !== pluginName) // Remove if already included
          : [...prevState, pluginName] // Add if not included
    );
  };

  const formatString = (str) => {
    // Replace underscores with spaces
    str = str.replace(/_/g, " ");

    // Add space before each capital letter, ensuring no double spaces
    str = str.replace(/([a-z])([A-Z])/g, "$1 $2");

    // Trim and return the final result
    return str.trim();
  };

  return (
    <>
      {open && (
        <div className="modal-zz-confirm text-left">
          <div
            className="p-2 scrollable-modal-content bg-white rounded"
            style={{ position: "relative" }}
          >
            {/* Info Message */}
            {assistant_type == "account" || assistant_type == "user" ? (
              <div
                style={{
                  backgroundColor: "#0588e9",
                  color: "white",
                  padding: "5px 10px",
                  borderRadius: "5px",
                  marginBottom: "12px",
                  marginTop: "20px",
                }}
              >
                <p style={{ fontSize: "13px" }}>
                  Warning: To update the template for all agents, please go to the User/Account
                  Templates tab. To update this agent only, you can make the changes directly from
                  this page.
                  <button
                    onClick={() => openUserAccountTemplates(item.assistant_name)}
                    style={{
                      marginLeft: "5px",
                      border: "none",
                      fontWeight: "bold",
                      backgroundColor: "transparent",
                      cursor: "pointer",
                    }}
                  >
                    Continue.
                  </button>
                </p>
              </div>
            ) : (
              ""
            )}
            {/* <h2 className="text-black text-left font-14" style={{ fontWeight: "700" }}>
              {" "}
              Edit Agent{" "}
            </h2> */}
            <span className="crossison" onClick={onClose}>
              X
            </span>
            {/* <SoftBox component="form" onSubmit={handleSubmit}>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <SoftBox className="mt-2">
                    <label className="text-black">Agent Name</label>
                    <input
                      className="form-control-agust"
                      placeholder="Agent Name"
                      name="assistant_name"
                      defaultValue={item.assistant_name}
                      required
                    />
                  </SoftBox>
                </Grid>

                <Grid item xs={12} style={{ marginTop: "14px" }}>
                  <SoftBox className="mt-2">
                    <label className="text-black" style={{ display: "flex", alignItems: "center" }}>
                      <span>Purpose</span>

                      <Tooltip
                        PopperProps={{
                          sx: {
                            "& .MuiTooltip-tooltip": {
                              maxWidth: "none",
                              width: "400px", // Set your desired width here
                            },
                          },
                        }}
                        placement="top"
                        title={supperAdminData?.assistant_purpose}
                      >
                        <img style={{ width: "30px", cursor: "pointer" }} src={infoimg} />
                      </Tooltip>
                    </label>

                    <textarea
                      className="form-control-agust"
                      name="purpose"
                      rows={4}
                      style={{
                        width: "100%",
                        padding: "14px",
                        resize: "vertical",
                      }}
                      defaultValue={item.purpose}
                      required
                    ></textarea>
                  </SoftBox>
                </Grid>

                <Grid item xs={6} style={{ marginTop: "10px" }}>
                  <SoftBox className="mt-2">
                    <label className="text-black" style={{ display: "flex", alignItems: "center" }}>
                      <span>Content Creativity</span>

                      <Tooltip
                        PopperProps={{
                          sx: {
                            "& .MuiTooltip-tooltip": {
                              maxWidth: "none",
                              width: "400px", // Set your desired width here
                            },
                          },
                        }}
                        placement="top"
                        title={supperAdminData?.content_creativity}
                      >
                        <img style={{ width: "30px", cursor: "pointer" }} src={infoimg} />
                      </Tooltip>
                    </label>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        value={contentCreativity}
                        type="range"
                        min="0"
                        max="2"
                        step=".01"
                        onChange={handleCCInputChange}
                        className="range-input"
                      />
                      <input
                        type="number"
                        value={contentCreativity}
                        min="0"
                        max="2"
                        step=".01"
                        onChange={(event) => handleCCInputChange(event)}
                        style={{
                          maxWidth: "50px",
                          fontSize: "14px",
                          margin: "2px",
                          padding: "0px 2px",
                          borderRadius: "5px",
                          border: "1px solid Black",
                        }}
                        className="height_25 bg_transparent"
                      />
                    </div>
                  </SoftBox>
                </Grid>

                <Grid item xs={6} style={{ marginTop: "10px" }}>
                  <SoftBox className="mt-2">
                    <label className="text-black" style={{ display: "flex", alignItems: "center" }}>
                      <span>Balance Text Generation</span>

                      <Tooltip
                        PopperProps={{
                          sx: {
                            "& .MuiTooltip-tooltip": {
                              maxWidth: "none",
                              width: "400px", // Set your desired width here
                            },
                          },
                        }}
                        placement="top"
                        title={supperAdminData?.balance_text_generation}
                      >
                        <img style={{ width: "30px", cursor: "pointer" }} src={infoimg} />
                      </Tooltip>
                    </label>

                    <div style={{ display: "flex", alignItems: "center" }}>
                      <input
                        value={btgen}
                        type="range"
                        min="0"
                        max="1"
                        step=".01"
                        onChange={handleBtInputChange}
                        className="range-input1"
                      />
                      <input
                        type="number"
                        value={btgen}
                        min="0"
                        max="1"
                        step="0.01"
                        onChange={(event) => handleBtInputChange(event)}
                        style={{
                          maxWidth: "50px",
                          fontSize: "14px",
                          margin: "2px",
                          padding: "0px 2px",
                          borderRadius: "5px",
                          border: "1px solid Black",
                        }}
                        className="height_25 bg_transparent"
                      />
                    </div>
                  </SoftBox>
                </Grid>
              </Grid>

              <SoftBox style={{ width: "100%", textAlign: "right" }} mt={2}>
                <Button onClick={handleAdvancedSettingsClick} style={{ color: "#000" }}>
                  Advanced Settings
                </Button>
              </SoftBox>

              {showAdvancedSettings && (
                <div style={{ padding: "10px" }}>
                  <h2
                    className="text-black text-left font-14"
                    style={{ fontWeight: "700", marginBottom: "20px", marginLeft: "-15px" }}
                  >
                    {" "}
                    Advance Setting{" "}
                  </h2>

                  <Grid container spacing={2}>
                 
                    {agency?.default_plugins && (
                      <>
                        <h2
                          className="text-black text-left font-14"
                          style={{ fontWeight: "700", marginBottom: "20px" }}
                        >
                          {" "}
                          Plugins{" "}
                        </h2>
                        {agency?.default_plugins?.map((plugin) => (
                          <Grid item xs={12} style={{ marginBottom: "20px" }} key={plugin.id}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <label className="text-black" style={{ marginRight: "10px" }}>
                                {formatString(plugin.name).toUpperCase()}
                              </label>
                              <Switch
                                checked={editplugins.includes(plugin.name)}
                                onChange={handlePluginsChange}
                                name={plugin.name}
                                inputProps={{ "aria-label": `Enable ${formatString(plugin.name)}` }}
                              />
                            </div>
                          </Grid>
                        ))}
                      </>
                    )}
                  </Grid>
                </div>
              )}

              <SoftBox mt={2}>
                <button className="savebtn-setting w-100" type="submit" disabled={waiting}>
                  {waiting && (
                    <div
                      class="spinner"
                      style={{
                        width: "16px",
                        height: "16px",
                        display: "inline-block",
                        marginRight: "8px",
                      }}
                    ></div>
                  )}
                  Update Agent
                </button>
              </SoftBox>
            </SoftBox> */}
          </div>
        </div>
      )}
    </>
  );
}

ModalComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleRefresh: PropTypes.func,
};

function Modal({
  item,
  handleRefresh,
  supperAdminData,
  assistant_type,
  pluginsdata,
  openUserAccountTemplates,
}) {
  const [openAddMember, setOpenAddMember] = useState(false);
  const [agency] = useAgencyInfo();
  return (
    <>
      <span
        onClick={async () => {
          if (item?.thread_id) {
            // agent-builder has no login/token of its own - it's an
            // Agency-session tool, so it borrows this session's token.
            const token = await localforage.getItem("token");
            window.open(
              `${env.AGENT_BUILDER_URL}agency_id=${agency._id}&thread_id=${item.thread_id}&token=${token}`,
              "agentBuilder",
              "width=1000,height=700,scrollbars=yes,resizable=yes,toolbar=no,menubar=no,location=no,directories=no,status=no"
            );
          } else {
            setOpenAddMember(true);
          }
        }}
      >
        <Icon>edit</Icon>
      </span>

      <ModalComponent
        open={openAddMember}
        onClose={() => setOpenAddMember(false)}
        item={item}
        handleRefresh={handleRefresh}
        supperAdminData={supperAdminData}
        assistant_type={assistant_type}
        pluginsdata={pluginsdata}
        openUserAccountTemplates={openUserAccountTemplates}
      />
    </>
  );
}

Modal.propTypes = {
  products: PropTypes.array,
  handleRefresh: PropTypes.func,
  apps: PropTypes.array,
};

export default Modal;
